import BarChartCoverage from "../graphs/barChartCoverage";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import NavBarMenu from "../NavBarMenu";
import FooterMenu from "../FooterMenu";

function Coverage() {
  return (
    <>
      <NavBarMenu />
      <main>
        <Container fluid>
          <Row className="display-flex">
            <Col>
              <BarChartCoverage />
            </Col>
          </Row>
        </Container>
      </main>
      <FooterMenu />
    </>
  );
}
export default Coverage;
